import socketIOClient from 'socket.io-client';
import logger from '@/logger';
import CONFIG from './config.js';

export default socket => {
	if (!socket) {
		const newSocket = socketIOClient(CONFIG.wsServerUrl, {
			'forceNew': true,
			'force new connection': true,
			transports: ['websocket'],
			upgrade: false,
		});

		logger.info('SOCKET CREATED', new Date().toLocaleTimeString());

		return newSocket;
	}
};
